import { CustomerConfig } from './types'

const config: CustomerConfig = {
  entraClientId: '9b48e51e-d038-4fb0-bec4-b2c1c2f442c8',
  header: 'Diabeteslinjen',
  headerLogoUrl: {
    light: '/logos/diabetes_logo.svg',
    dark: '/logos/diabetes_logo.svg',
  },
  subheader: '',
  version: 'Beta 1',
  logo: 'diabetes_logo_farget.svg',
  theme: {
    isLight: true,
    bgColor: 'bg-blue-800',
    textColor: 'text-blue-800',
    bubbles: 'bg-green-600',
  },
  chatServer:
    (process.env.REACT_APP_CHAT_SERVER || 'https://ai.semanticlab.no') +
    '/api/v1/chatbots/diabetes',
  copyButtonFormat: 'plain',
}
export default config
